
import { defineComponent, ref, onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import { ElLoadingService } from "element-plus";
import { getExamInfo } from "@/services";
import { MutationNames, useStore } from "@/store";
import useExam from "@/hooks/useExam";
import { updateExamStatus } from "@/services/proctor";

export default defineComponent({
  setup() {
    const _store = useStore();
    let examData = ref<any>({});
    let examList: any = ref({});
    let isExam = ref(false); // 是否有考试
    let noExamTxt = ref(""); // 是否有考试
    let examPaperLoading = ref(false);
    let examPaperLoadingText = ref("正在准备测评数据中...");
    const router = useRouter();
    const { getExamPaper, showExamMessageBox } = useExam();

    const goToHome = () => {
      router.push({
        path: "/home",
      });
    };
    const goToExamRecord = () => {
      router.push({
        path: "/examRecord",
        query: { type: "exam" },
      });
    };
    const startExam = async () => {
      // const loading = ElLoadingService({
      //   text: "正在准备测评数据中...",
      // });
      examPaperLoading.value = true;
      const exam = { examType: "exam" };
      updateExamStatus({ status: 2, exam_id: examData.value.id });
      getExamPaper(exam)
        .then(() => {
          // loading.close();
          examPaperLoading.value = false;
          router.push({
            path: "/deviceCheck",
            query: { overType: "goExam" },
          });
        })
        .catch((e) => {
          // loading.close();
          examPaperLoading.value = false;
          showExamMessageBox({
            message: "系统出错，获取测评数据失败，请联系监考老师！",
          });
          console.error("getExamPaper错误");
          console.error(e);
        });
    };
    onBeforeMount(() => {
      getExamInfo().then((data: any) => {
        // if (data.active_exam === undefined) {
        if (!data.active_exam) {
          noExamTxt.value = "近期内暂无测评!";
        } else {
          // examData.value = data.active_exam;
          isExam.value = true;
          examData.value = data.active_exam;
          _store.commit(MutationNames.CHANGE_EXAMINFO, data);
          noExamTxt.value = "";
        }
      });
    });

    return {
      noExamTxt,
      examData,
      examList,
      isExam,
      goToHome,
      startExam,
      goToExamRecord,
      examPaperLoading,
      examPaperLoadingText,
    };
  },
});
